import { memo } from 'react';
import { cn } from '@page/ui';
import { CheckCircleIcon } from '@page/icons';

import { keys } from '@page/core/utils/object';
import { PasswordCriteria, PasswordCriterion } from '@page/auth/services/password/password.service';

interface PasswordCriteriaHintsProps {
  criteria: Record<PasswordCriteria, PasswordCriterion>;
}

const PasswordCriteriaHintsBase = ({ criteria }: PasswordCriteriaHintsProps) => {
  return (
    <div className="flex flex-col mb-6 gap-2">
      {keys(criteria).map((criteriaKey) => (
        <div key={criteriaKey} className="flex items-center gap-1">
          {criteria[criteriaKey].isValid ? (
            <CheckCircleIcon className="size-5 fill-text-success" />
          ) : (
            <div className="size-5 grid place-items-center">
              <div className="bg-bg-sur-primary size-[14px] rounded-full border-[1.5px] border-text-warning" />
            </div>
          )}
          <span
            className={cn(
              'font-body-sm transition-all',
              criteria[criteriaKey].isValid ? 'text-text-success' : 'text-text-warning',
            )}
          >
            {criteria[criteriaKey].label}
          </span>
        </div>
      ))}
    </div>
  );
};

export const PasswordCriteriaHints = memo(PasswordCriteriaHintsBase);
